/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IDirectAdmissionScope extends ng.IScope {
        vm: DirectAdmission;
    }

    interface IDirectAdmission {
        expanded: boolean;
        applications: Array<directAdmissionViewModel>;
        crossroadsUrl: string;
        umbracoUrl: string;
        apiHost: string;
        transcripts: Array<any>;
        getUserApplicationsTryCount: number;
    }

    class DirectAdmission implements IDirectAdmission {
        static controllerId: string = "directAdmission";
        static $inject: Array<string> = ["$scope",
            "$window",
            "applicationsDataService",
            "common",
            "config",
            "Restangular",
            "Upload",
            "$http",
            "$location",
            "$document",
            "$interval",
            "Idle",
            "helper",
            "$cookies"
        ];
        private log;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        expanded: boolean;
        applications: Array<directAdmissionViewModel>;
        crossroadsUrl: string;
        apiHost: string;
        transcripts: Array<any>;
        getUserApplicationsTryCount: number = 0;
        errorGettingApplications: boolean = false;
        printing: any;
        emailing: any;
        refreshing: boolean = false;
        alerts: Array<any> = [];
        childWindows: Array<any> = [];
        timer: any = 0;
        userInfo: IUserInfoView;
        apphubNotification: any;
        user: any;
        savingDetails: boolean = false;
        noStudentNumber: boolean;
        eligible: boolean;
        umbracoUrl: string;
        ineligible: boolean;

        constructor(private $scope: ng.IScope,
            private $window: ng.IWindowService,
            private applicationsDataService: IApplicationsDataService,
            private common: ICommonFactory,
            private config: IConfig,
            private Restangular: Restangular.IService,
            private Upload,
            private $http: any,
            private $location: ng.ILocationService,
            private $document: ng.IDocumentService,
            private $interval: ng.IIntervalService,
            private Idle,
            private helper: IHelper,
            private $cookies: angular.cookies.ICookiesService) {
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.log = common.logger.getLogFn(DirectAdmission.controllerId);
                    this.logError = common.logger.getLogFn(DirectAdmission.controllerId, "error");
                    this.logSuccess = common.logger.getLogFn(DirectAdmission.controllerId, "success");


                    this.common.authentication.isLoggedIn().then(loggedIn => {
                        if (loggedIn) {
                            this.userInfo = this.common.authentication.user;
                            this.activate();
                            this.expanded = false;
                            this.crossroadsUrl = config.crossroadsUrl;
                            this.apiHost = config.apiHost;
                            this.umbracoUrl = this.config.umbracoUrl;
                            console.log(config);
                        }
                    });



                }
            });


            $scope.$on('$destroy', function () {
                Idle.watch();
            });
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, DirectAdmission.controllerId)
                .then(() => {
                    this.eligible = false;
                    this.refreshing = true;
                    this.applications = null;
                    this.getProfile();

                    this.log("Activated Direct Admissions View");

                });
        }

        getProfile() {
            this.Restangular.one("users/profile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        if (this.user.studentId != null && this.user.studentId != '') {
                            this.getEligibility();
                        }
                        else
                            this.noStudentNumber = true;
                    }
                }, (reason) => {
                    this.logError(reason);
                });
        }

        updateUser = () => {
            this.savingDetails = true;
            var params = { userId: this.user.id, studentNumber: this.user.studentId };
            this.Restangular.all("users/studentNumber/save").post(params)
                .then((result) => {
                    this.noStudentNumber = false;
                    this.savingDetails = false;
                    this.getEligibility();
                    this.logSuccess("Your profile has been updated.", result, true);
                }, (reason) => {
                    switch (reason.status) {
                        case 400:
                            if (reason.data.modelState) {
                                for (var key in reason.data.modelState) {
                                    reason.data.modelState[key].forEach((s) => {
                                        this.logError(s, s, true);
                                        this.savingDetails = false;
                                    });
                                };
                            }
                            break;
                        case 500:
                            this.logError(reason, reason.data, true);
                            this.savingDetails = false;
                            break;
                    }

                    this.savingDetails = false;
                })
        };

        getEligibility() {
            this.applicationsDataService.getDirectAdmissionEligibility(this.user.lastName, this.user.studentId).then((data) => {
                if (data.ceebCode == null) {
                    this.ineligible = true;
                }
                else {
                    this.ineligible = false;
                    this.getUserApplications();
                }
            }, (reason) => {
                console.log(reason);
            });
        }

        getUserApplications() {
            this.applications = null;
            this.applicationsDataService.getDirectAdmissionApplications(this.user.studentId).then((data) => {
                this.applications = data;
            }, (reason) => {
                console.log(reason);
            });
        }

        viewProfile()
        {
            var appWindow = this.$window.open(this.config.cfncUrl + "/profile", "_blank");
            this.addChildWindow(appWindow);
        }

        viewApp = (selectedApp) => {
            var appWindow;
            this.Restangular.one("Prospect/" + selectedApp.applicationId).one("isRecruited").get().then((results) => {
                if (!results) {
                    this.Restangular.all("Prospect/addRecruiter").post({ applicationDefinitionId: selectedApp.applicationId, source: "Application" })
                        .then((results) => {
                            console.log(results);
                        }, (reason) => {
                            console.error(reason);
                        });
                }
            }, (reason) => {
                console.error(reason);
            });
            this.$cookies.put("CollegeConnectOrigin", "Yes", { domain: '.cfnc.org', expires: moment().add(5,'minutes').toString()});
            appWindow = this.$window.open(this.config.crossroadsUrl + "/" + selectedApp.viewUrl, "_blank");

            this.addChildWindow(appWindow);
        };

        addChildWindow = (appWindow) => {
            this.childWindows.push(appWindow);
            if (this.timer == 0) {
                console.log("timer started");
                this.Idle.unwatch();
                this.timer = this.$interval(this.checkWindow, 1000, 0, true);
            }
        };

        checkWindow = () => {
            for (var win = 0; win < this.childWindows.length; win++) {
                if (!this.childWindows[win]) {
                    this.childWindows.splice(win, 1);
                }
                else if (this.childWindows[win].closed) {
                    this.childWindows.splice(win, 1);
                    this.activate();
                }
            }

            if (this.childWindows.length == 0) {
                this.$interval.cancel(this.timer);
                this.timer = 0;
                this.Idle.watch();
            }
        }
    }

    angular.module("app").controller(DirectAdmission.controllerId, DirectAdmission);
}